export default "__VITE_ASSET__CT5pv5Ip__"